export default __webpack_public_path__ + "static/media/ornament2.cbfd8984.png";